/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react';
import styled from '@emotion/styled';
import NextImage from 'next/legacy/image';
import Button from 'aquilla/core/molecules/Button';
import H1 from '@base/H1/H1';
import Image from '@base/Image';
import Carousel from 'aquilla/core/molecules/Carousel';
import { useIsMobile } from '@stores/AppCommonData';
import { Spacings, mediaQuery, Fonts } from '@styles/index';
import { getImage } from '@utils/imageHelper';
import Play from 'aquilla/icons/actions/Play';
import P1 from '@base/P1/P1';
import useCertificationCourseData from './useCertificationCourseData';

const BannerWrapper = styled.div`
  width: 100%;
  height: 568px;
  position: relative;
  display: flex;
  overflow: hidden;
  background-color: ${({ $courseBackground }) =>
    `${$courseBackground}` ?? 'grey'};
  ${mediaQuery.uptoMobile} {
    flex-direction: column-reverse;
    height: auto;
  }
`;

const FrameHolder = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  ${mediaQuery.uptoMobile} {
    display: none;
  }
`;

const BackGroundImage = styled(Image)`
  height: 100%;
  width: 30vw;
`;
const LeftContainer = styled.div`
  padding: 30px 68px 78px 0px;
  display: flex;
  flex-direction: column;
  ${mediaQuery.uptoMobile} {
    width: 100%;
    padding: ${Spacings.SPACING_0B};
  }
`;
const SubContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const RightContainer = styled.div`
  height: 100%;
  width: 49vw;
  position: relative;
  ${mediaQuery.uptoMobile} {
    width: 100%;
    padding: ${Spacings.SPACING_0B};
  }
`;

const YoutubeIframePlayer = styled.iframe`
  width: 49vw;
  height: 568px;
  border-radius: ${Spacings.SPACING_2B};
  ${mediaQuery.uptoMobile} {
    width: 100%;
    height: 220px;
  }
`;

const StyledImage = styled(Image)`
  height: 100%;
  width: 49vw;
  ${mediaQuery.uptoMobile} {
    border-radius: ${Spacings.SPACING_1B};
    width: 100%;
    height: 220px;
  }
`;

const ProgrammeTitle = styled(H1)`
  font-weight: ${Fonts.HEAVY};
  line-height: ${Spacings.SPACING_12B};
  font-size: ${Fonts.H1};
  color: white;
  max-width: 90%;
  margin-bottom: ${Spacings.SPACING_4B};
  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.H4};
    line-height: 26px;
  }
`;

const StyledP1 = styled(P1)`
  color: white;
  font-weight: ${Fonts.LIGHT};
  line-height: ${Spacings.SPACING_5B};
`;

const ProgrammeConductor = styled(P1)`
  color: white;
  font-weight: ${Fonts.LIGHT};
  line-height: ${Spacings.SPACING_5B};
  margin-bottom: ${Spacings.SPACING_6B};
`;

const ProgrammeTimings = styled(P1)`
  font-weight: ${Fonts.SEMIBOLD};
  color: white;
  line-height: ${Spacings.SPACING_5B};
  ${mediaQuery.uptoMobile} {
    max-width: 96%;
  }
`;

const ProgrammeStatisticsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: ${Spacings.SPACING_9B};
  gap: 16px;
  ${mediaQuery.uptoMobile} {
    margin-bottom: ${Spacings.SPACING_6B};
  }
`;

const StyledOrganisationLogo = styled(Image)`
  width: 128px;
  height: 32px;
  margin-bottom: ${Spacings.SPACING_4B};
  ${mediaQuery.uptoMobile} {
    margin-bottom: ${Spacings.SPACING_3B};
  }
`;

const PlayButtonContainer = styled.div`
  background-color: white;
  opacity: 0.5;
  height: 88px;
  width: 88px;
  border-radius: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
  ${mediaQuery.uptoMobile} {
    display: none;
  }
`;

const CTAHolder = styled.div`
  display: flex;
  gap: ${Spacings.SPACING_4B};
  ${mediaQuery.uptoMobile} {
    display: grid;
    width: 96%;
  }
`;
const FooterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacings.SPACING_4B};
  ${mediaQuery.uptoMobile} {
    gap: ${Spacings.SPACING_6B};
  }
`;

const PlayButton = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 100%;
  background-color: white;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  ${mediaQuery.uptoMobile} {
    width: 40px;
    height: 40px;
    top: unset;
    bottom: 15%;
    left: 7%;
    transform: unset;
  }
`;

const ProgrammeStatisticsCardContainer = styled.div`
  flex: 0 0 250px;
  display: flex;
  align-items: center;
  gap: ${Spacings.SPACING_3B};
`;

const StatisticsIconWrapper = styled.div`
  background-color: var(--color-i-gray-34);
  height: 32px;
  width: 32px;
  min-width: 32px;
  min-height: 32px;
  border-radius: ${Spacings.SPACING_1B};
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledButton = styled(Button)`
  width: 255px;
  height: 48px;
  font-weight: ${Fonts.SEMIBOLD};
  font-size: ${Fonts.LARGE};
  background-color: ${({ $isTransparent }) =>
    $isTransparent ? 'transparent' : 'none'};
  border-color: white;

  &:hover {
    background-color: ${({ $isTransparent }) =>
      $isTransparent ? 'transparent' : 'none'};
  }

  ${mediaQuery.uptoMobile} {
    width: auto;
  }
`;

const SubWrapper = styled.div`
  display: flex;
  width: 1136px;
  margin: auto;
  height: 100%;
  height: 568px;
  ${mediaQuery.uptoMobile} {
    width: 100%;
    flex-direction: column-reverse;
    height: auto;
    padding: ${Spacings.SPACING_6B} ${Spacings.SPACING_4B};
    gap: ${Spacings.SPACING_5B};
  }
`;

const DownloadIcon = () => {
  return (
    <NextImage
      src={getImage('programmes/download-brochure-icon.svg')}
      width={24}
      height={24}
    />
  );
};

const ProgrammeStatisticsCard = ({ programeStatistics }) => {
  return (
    <ProgrammeStatisticsCardContainer>
      <StatisticsIconWrapper>
        {programeStatistics?.icon && (
          <NextImage src={programeStatistics?.icon} width={16} height={16} />
        )}
      </StatisticsIconWrapper>
      <StyledP1>{programeStatistics?.label}</StyledP1>
    </ProgrammeStatisticsCardContainer>
  );
};

const CourseBanner = ({
  goalUID,
  handleInterestedCTA,
  handleDownloadBrochureCTA
}) => {
  const [showYoutubeIframe, setShowYoutubeIframe] = useState(false);
  const {
    overAll,
    sections: { banner: bannerDetails }
  } = useCertificationCourseData(goalUID);
  const isMobile = useIsMobile();
  return (
    <BannerWrapper $courseBackground={bannerDetails?.programmeThemeColor}>
      <SubWrapper>
        <LeftContainer>
          {!isMobile && (
            <FrameHolder>
              <BackGroundImage
                src="programmes/programme-frame.svg"
                layout="fill"
              />
            </FrameHolder>
          )}
          <SubContainer>
            <StyledOrganisationLogo
              src={bannerDetails?.programmeLogo}
              alt="Organisation Logo"
            />
            <ProgrammeTitle>{bannerDetails?.programmeTitle}</ProgrammeTitle>
            <ProgrammeConductor>
              {bannerDetails?.programmeDescription}
            </ProgrammeConductor>
            <ProgrammeStatisticsWrapper>
              {bannerDetails?.programmeStatistics?.map((item) => (
                <ProgrammeStatisticsCard
                  key={item.uid}
                  programeStatistics={item}
                />
              ))}
            </ProgrammeStatisticsWrapper>
          </SubContainer>
          <FooterWrapper>
            <ProgrammeTimings>
              {overAll?.startInMessage} &#183;{' '}
              {overAll?.enrollmentEndDetails?.label}
            </ProgrammeTimings>
            <CTAHolder>
              <StyledButton
                onClick={handleInterestedCTA}
                size="large"
                variant="secondary"
                label="I’m interested"
              />
              <StyledButton
                onClick={handleDownloadBrochureCTA}
                size="large"
                $isTransparent
                label="Download brochure"
                startIcon={<DownloadIcon />}
              />
            </CTAHolder>
          </FooterWrapper>
        </LeftContainer>
        <RightContainer>
          {!showYoutubeIframe ? (
            <>
              {bannerDetails?.isCarousalPresent ? (
                <Carousel
                  itemsPerSlide={1}
                  variant="single"
                  mode="auto"
                  controls={{ showArrows: true }}
                >
                  {bannerDetails?.programmeImages?.map((programmeImage) => (
                    <StyledImage
                      src={programmeImage.src}
                      key={programmeImage.uid}
                    />
                  ))}
                </Carousel>
              ) : (
                <>
                  <StyledImage src={bannerDetails?.programmeImages[0]?.src} />
                  {bannerDetails?.isVideoPresent && !showYoutubeIframe && (
                    <div onClick={() => setShowYoutubeIframe(true)}>
                      <PlayButtonContainer />
                      <PlayButton>
                        <Play
                          height={isMobile ? 14 : 20}
                          width={isMobile ? 14 : 20}
                        />
                      </PlayButton>
                    </div>
                  )}
                </>
              )}
            </>
          ) : (
            <YoutubeIframePlayer
              src={`${bannerDetails?.programmeVideoLink}/?&modestbranding=1&autoplay=1&playsinline=1`}
              frameBorder="0"
              allowFullScreen
              playsInline
              allow="autoplay"
              title={bannerDetails?.programmeTitle}
              controls="0"
            />
          )}
        </RightContainer>
      </SubWrapper>
    </BannerWrapper>
  );
};

export default CourseBanner;
